// extracted by mini-css-extract-plugin
module.exports = {"campaignLifeCycle":"ProductCampaignLifeCycle_campaignLifeCycle__08SBE"};